import { render, staticRenderFns } from "./EmbryoStockPage.vue?vue&type=template&id=75f786a6&scoped=true&"
import script from "./EmbryoStockPage.vue?vue&type=script&lang=js&"
export * from "./EmbryoStockPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f786a6",
  null
  
)

export default component.exports